import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const EmailInput = ({ value, onChange }) => {
  const handleChange = (field, fieldValue) => {
    onChange({
      ...value,
      [field]: fieldValue
    });
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Icon name="Mail" size={18} color="var(--color-accent)" strokeWidth={2} />
        <label className="text-sm font-caption font-medium text-foreground">
          Email Message Details
        </label>
      </div>
      <Input
        label="Recipient Email"
        type="email"
        value={value?.recipient || ''}
        onChange={(e) => handleChange('recipient', e?.target?.value)}
        placeholder="recipient@example.com"
        required
      />
      <Input
        label="Subject Line"
        type="text"
        value={value?.subject || ''}
        onChange={(e) => handleChange('subject', e?.target?.value)}
        placeholder="Enter email subject"
      />
      <div className="space-y-2">
        <label className="text-sm font-caption font-medium text-foreground">
          Message Body
        </label>
        <textarea
          value={value?.body || ''}
          onChange={(e) => handleChange('body', e?.target?.value)}
          placeholder="Type your email message here..."
          rows={5}
          className="w-full px-4 py-3 rounded-lg border border-input bg-background text-foreground dark:text-white text-sm font-body resize-none focus:outline-none focus:ring-2 focus:ring-ring transition-smooth"
        />
      </div>
      <div className="flex items-start gap-2 p-3 rounded-lg bg-muted/30 border border-border">
        <Icon name="Info" size={16} color="var(--color-muted-foreground)" strokeWidth={2} className="mt-0.5 flex-shrink-0" />
        <p className="text-xs font-caption text-muted-foreground leading-relaxed">
          Scanning this QR code will open the user's default email client with the recipient, subject, and body pre-filled.
        </p>
      </div>
    </div>
  );
};

export default EmailInput;